(function () {
  var coffeeId = String(window.__AH_COFFEE_VARIANT_ID__ || '');
  if (!coffeeId || typeof window.fetch !== 'function') return;

  var nativeFetch = window.fetch.bind(window);
  var purging = false;

  function isCoffeeId(id) {
    return String(id || '') === coffeeId;
  }

  function isWorkshopLine(item) {
    if (!item) return false;
    var props = item.properties || {};
    if (String(props._workshop_addon) === 'true') return false;
    var handle = String(item.handle || '').toLowerCase();
    if (handle === 'turkish-coffee') return false;
    if (handle.indexOf('workshop') !== -1) return true;
    return String(props._is_workshop) === '1' || !!props._event_id;
  }

  function isWorkshopProps(props) {
    return isWorkshopLine({ properties: props || {} });
  }

  function coffeeAddonOnly(items) {
    var coffee = (items || []).filter(function (item) {
      return item && isCoffeeId(item.id);
    });
    if (!coffee.length) return false;
    return coffee.every(function (item) {
      return item.properties && String(item.properties._workshop_addon) === 'true';
    });
  }

  function cartHasWorkshop() {
    return nativeFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        return ((cart && cart.items) || []).some(isWorkshopLine);
      })
      .catch(function () {
        return false;
      });
  }

  function coffeeAllowed(items) {
    var hasWorkshop = false;
    var coffee = [];
    (items || []).forEach(function (item) {
      if (!item) return;
      if (isCoffeeId(item.id)) coffee.push(item);
      else if (isWorkshopProps(item.properties)) hasWorkshop = true;
    });
    if (!coffee.length) return true;
    if (!hasWorkshop) return false;
    return coffee.every(function (item) {
      return item.properties && String(item.properties._workshop_addon) === 'true';
    });
  }

  function rejectCoffee() {
    return Promise.resolve(
      new Response(
        JSON.stringify({
          status: 422,
          message: 'Turkish Coffee can only be added with a workshop.',
          description: 'Turkish Coffee can only be added with a workshop.',
        }),
        { status: 422, headers: { 'Content-Type': 'application/json' } }
      )
    );
  }

  function readItems(body) {
    if (!body) return null;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var items = [];
      var singleId = body.get('id');
      if (singleId) {
        var props = {};
        body.forEach(function (value, key) {
          var match = String(key).match(/^properties\[(.+)\]$/);
          if (match) props[match[1]] = value;
        });
        items.push({ id: singleId, properties: props, single: true });
      }
      var grouped = {};
      body.forEach(function (value, key) {
        var idMatch = String(key).match(/^items\[(\d+)\]\[id\]$/);
        if (idMatch) grouped[idMatch[1]] = { id: value, properties: {}, index: idMatch[1] };
      });
      body.forEach(function (value, key) {
        var propMatch = String(key).match(/^items\[(\d+)\]\[properties\]\[(.+)\]$/);
        if (propMatch && grouped[propMatch[1]]) grouped[propMatch[1]].properties[propMatch[2]] = value;
      });
      Object.keys(grouped).forEach(function (key) {
        items.push(grouped[key]);
      });
      return { kind: 'form', items: items, raw: body };
    }
    if (typeof body === 'string') {
      try {
        body = JSON.parse(body);
      } catch (e) {
        return null;
      }
    }
    if (!body || typeof body !== 'object') return null;
    if (Array.isArray(body.items)) return { kind: 'json-items', items: body.items, raw: body };
    if (body.id) return { kind: 'json-one', items: [body], raw: body };
    return null;
  }

  function stripCoffeeForm(raw, items) {
    items.forEach(function (item) {
      if (!isCoffeeId(item.id) || item.single) return;
      var prefix = 'items[' + item.index + ']';
      var drop = [];
      raw.forEach(function (_value, key) {
        if (String(key).indexOf(prefix) === 0) drop.push(key);
      });
      drop.forEach(function (key) {
        raw.delete(key);
      });
    });
    if (raw.get('id') && isCoffeeId(raw.get('id'))) {
      raw.delete('id');
      raw.delete('quantity');
      var propKeys = [];
      raw.forEach(function (_value, key) {
        if (String(key).indexOf('properties[') === 0) propKeys.push(key);
      });
      propKeys.forEach(function (key) {
        raw.delete(key);
      });
    }
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var adding = /\/cart\/add(\.js)?(\?|$)/.test(url);
    if (adding && init && init.body) {
      var parsed = readItems(init.body);
      if (parsed && !coffeeAllowed(parsed.items)) {
        var rest = parsed.items.filter(function (item) {
          return !isCoffeeId(item.id);
        });
        if (!rest.length && coffeeAddonOnly(parsed.items)) {
          return cartHasWorkshop().then(function (ok) {
            if (!ok) return rejectCoffee();
            return nativeFetch(input, init).then(function (response) {
              return response;
            });
          });
        }
        if (!rest.length) return rejectCoffee();
        if (parsed.kind === 'json-items') {
          parsed.raw.items = parsed.raw.items.filter(function (item) {
            return !isCoffeeId(item.id);
          });
          init = Object.assign({}, init, { body: JSON.stringify(parsed.raw) });
        } else if (parsed.kind === 'form') {
          stripCoffeeForm(parsed.raw, parsed.items);
        } else {
          return rejectCoffee();
        }
      }
    }
    return nativeFetch(input, init).then(function (response) {
      if (!/\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url) || purging) return response;
      return settleCoffee(response, init);
    });
  };

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest && event.target.closest('[data-ah-coffee-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    var id = btn.getAttribute('data-ah-coffee-variant');
    if (!id) return;
    btn.disabled = true;
    var sections = [];
    try {
      if (window.Alpine && Alpine.store && Alpine.store('xCartHelper')) {
        sections = Alpine.store('xCartHelper')
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          });
      }
    } catch (e) {}
    window
      .fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: Number(id),
              quantity: 1,
              properties: { _workshop_addon: 'true', _addon_title: 'Turkish Coffee' },
            },
          ],
          sections: sections.join(','),
        }),
      })
      .then(function (response) {
        return response.json().then(function (body) {
          return { ok: response.ok, body: body };
        });
      })
      .then(function (result) {
        if (!result.ok || result.body.status === 422) {
          btn.disabled = false;
          return;
        }
        try {
          if (window.Alpine && Alpine.store('xCartHelper') && result.body.sections) {
            Alpine.store('xCartHelper').reRenderSections(result.body.sections);
          }
          if (window.Alpine && Alpine.store('xMiniCart')) Alpine.store('xMiniCart').reLoad();
        } catch (e) {}
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      })
      .catch(function () {
        btn.disabled = false;
      });
  });

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      var idInput = form.querySelector('[name="id"]');
      if (!idInput || !isCoffeeId(idInput.value)) return;
      var addon = form.querySelector('[name="properties[_workshop_addon]"]');
      if (addon && String(addon.value) === 'true') return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  function isCoffeeLine(item) {
    if (!item) return false;
    return (
      String(item.variant_id) === coffeeId ||
      isCoffeeId(item.id) ||
      isCoffeeId(item.variant_id) ||
      item.handle === 'turkish-coffee'
    );
  }

  function coffeeKeysToRemove(items) {
    var list = items || [];
    var hasWorkshop = list.some(isWorkshopLine);
    var keys = [];
    list.forEach(function (item) {
      if (!isCoffeeLine(item) || !item.key) return;
      var props = item.properties || {};
      if (!hasWorkshop || String(props._workshop_addon) !== 'true') keys.push(item.key);
    });
    return keys;
  }

  function requestCartOptions(init) {
    var sections = '';
    var sectionsUrl = window.location.pathname;
    try {
      var body = init && init.body;
      if (typeof body === 'string') body = JSON.parse(body);
      if (body && body.sections) {
        sections = Array.isArray(body.sections) ? body.sections : String(body.sections).split(',');
      }
      if (body && body.sections_url) sectionsUrl = body.sections_url;
    } catch (e) {}
    if (!sections || !sections.length) {
      try {
        if (window.Alpine && Alpine.store('xCartHelper')) {
          sections = Alpine.store('xCartHelper')
            .getSectionsToRender()
            .map(function (section) {
              return section.id;
            });
        }
      } catch (e) {}
    }
    return { sections: sections, sections_url: sectionsUrl };
  }

  function jsonResponse(cart) {
    return new Response(JSON.stringify(cart), {
      status: 200,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  function removeCoffeeKeys(keys, init) {
    var updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });
    var options = requestCartOptions(init);
    purging = true;
    return nativeFetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: options.sections,
        sections_url: options.sections_url,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        purging = false;
        refreshCartUi();
        return cart;
      })
      .catch(function () {
        purging = false;
        return null;
      });
  }

  function refreshCartUi() {
    try {
      if (window.Alpine && Alpine.store('xCartHelper')) Alpine.store('xCartHelper').reRenderSections();
    } catch (e) {}
  }

  function settleCoffee(response, init) {
    return response
      .clone()
      .json()
      .then(function (cart) {
        var keys = coffeeKeysToRemove(cart && cart.items);
        if (!keys.length) return response;
        return removeCoffeeKeys(keys, init).then(function (updated) {
          return updated ? jsonResponse(updated) : response;
        });
      })
      .catch(function () {
        return response;
      });
  }

  function purgeSoloCoffee() {
    if (purging) return Promise.resolve();
    return nativeFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var keys = coffeeKeysToRemove(cart && cart.items);
        if (!keys.length) return null;
        return removeCoffeeKeys(keys);
      })
      .catch(function () {});
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.getAttribute('data-ah-coffee-pass') === '1') return;
      var action = String(form.getAttribute('action') || form.action || '');
      if (action.indexOf('/cart') === -1) return;
      var submitter = event.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      event.preventDefault();
      event.stopPropagation();
      purgeSoloCoffee().then(function () {
        form.setAttribute('data-ah-coffee-pass', '1');
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter);
        else form.submit();
      });
    },
    true
  );

  document.addEventListener('eurus:cart:items-changed', purgeSoloCoffee);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', purgeSoloCoffee);
  } else {
    purgeSoloCoffee();
  }
})();
